import { render, staticRenderFns } from "./DetailBody.vue?vue&type=template&id=34d74960&scoped=true"
import script from "./DetailBody.vue?vue&type=script&lang=js"
export * from "./DetailBody.vue?vue&type=script&lang=js"
import style0 from "./DetailBody.vue?vue&type=style&index=0&id=34d74960&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d74960",
  null
  
)

export default component.exports